
const maw = (d)=>`@media (max-width: ${d}px)`;
const miw = (d)=>`@media (min-width: ${d}px)`;
const maiw = (max,min)=>`@media (min-width: ${min}px) and (max-width: ${max}px)`;

export const smallBreakpoint = 640;
export const mediumBreakpoint = 1300;

export const bpSmallOnly = maw(smallBreakpoint);
export const bpMediumOnly = maiw(mediumBreakpoint,smallBreakpoint);
export const bpMediumUp = miw(smallBreakpoint);
export const bpLarge = miw(mediumBreakpoint);